<!--血常规及尿常规-->
<script setup>
import { reactive, computed ,ref} from "vue";
import { useCrfStore } from "@/stores/crf";
import upload from "@/components/upload1.vue"
import check from "./check.vue";
import {useCommonStore} from "@/stores/common.js"
const commonStore = useCommonStore()
//不是筛选期
let notScreen = ref(false)
notScreen.value = commonStore.funNotScreen

//是不是v0
let isv0 = ref(false)
isv0.value = commonStore.isV0

// 定义组件属性
const props = defineProps({
  formModel: {},
  type: null
});

// 表单对象
const model = reactive(props.formModel);
const crfStore = useCrfStore();

const isVisible = computed(() => {
  let result = {};
  ["尿常规"].forEach((field) => {
    result[field] = model.fields[field] === "异常";
  });
  return result;
});

// 节省代码长度，在模板中使用
const crfFields = computed(() => {
  return model.fields[`${props.type}`];
});

// 字段自动校验用于赋值 prop
const itemProp = function(prop) {
  return `fields['${props.type}']['${prop}']`;
};
</script>

<template>
  <template v-if="crfFields">
     <div style="display:flex;">
      
      <h2>血常规</h2>
      <upload :type="props.type" :data="model" name="xcgjncg"></upload>
      <check :period="props.type" text="血常规" :data="model" v-if="model.checkdata.ischeck == '是'"></check>

    </div>
    <el-form-item label="血常规是否适用肝筛选期数据"  v-if="crfFields && isv0" class="redStar">
      <el-radio-group v-if="notScreen" v-model="crfFields['血常规是否适用肝筛选期数据']">
        <el-radio label="是" prop="是"></el-radio>
        <el-radio label="否" prop="否"></el-radio>
      </el-radio-group>
    </el-form-item>
      <template v-if="crfFields['血常规是否适用肝筛选期数据'] == '否' || !isv0">
        <el-form-item :label="notScreen?'是否新增血常规':'血常规'"  v-if="crfFields && notScreen" class="redStar">
            <el-radio-group v-if="notScreen" v-model="crfFields['是否新增血常规']">
              <el-radio label="是" prop="是"></el-radio>
              <el-radio label="否" prop="否"></el-radio>
            </el-radio-group>

        </el-form-item>
        
        <template v-if="crfFields['是否新增血常规'] == '是' || !notScreen">
            <el-form-item label="白细胞计数（10⁹/L）" class="redStar" :prop="itemProp(`白细胞计数`)" :rules="crfStore.textRules(`白细胞计数`,true)">
              <el-input v-model="crfFields['白细胞计数']" autocomplete="off">
                <template #append>10⁹/L</template>
              </el-input>
            </el-form-item>
            <el-form-item label="血红蛋白（g/L）" class="redStar" :prop="itemProp(`血红蛋白`)" :rules="crfStore.textRules(`血红蛋白`,true)">
              <el-input v-model="crfFields['血红蛋白']" autocomplete="off">
                <template #append>g/L</template>
              </el-input>
            </el-form-item>
            <el-form-item label="血小板计数（10⁹/L）" class="redStar" :prop="itemProp(`血小板计数`)" :rules="crfStore.textRules(`血小板计数`,true)">
              <el-input v-model="crfFields['血小板计数']" autocomplete="off">
                <template #append>10⁹/L</template>
              </el-input>
            </el-form-item>
            <el-form-item label="网织红细胞计数（%）" class="redStar" :prop="itemProp(`网织红细胞计数`)" :rules="crfStore.textRules(`网织红细胞计数`,true)">
              <el-input v-model="crfFields['网织红细胞计数']" autocomplete="off">
                <template #append>%</template>
              </el-input>
            </el-form-item>

            <el-form-item label="HS-CRP（mg/L）" class="redStar" :prop="itemProp(`HS-CRP（mg/L）`)" :rules="crfStore.textRules(`HS-CRP`,true)">
              <el-input v-model="crfFields['HS-CRP（mg/L）']" autocomplete="off">
                <template #append>mg/L</template>
              </el-input>
            </el-form-item>
        </template>
      </template>
   
    <el-form-item v-if="isVisible['尿常规']"  label="尿常规：异常描述" class="redStar">
      <el-input v-model="crfFields['尿常规：异常描述']" type="textarea"></el-input>
    </el-form-item>

  </template>
</template>

<style scoped>

</style>